(function () {
  'use strict';
  if (window.TTCartUpsell) return;
  window.TTCartUpsell = { version: '1.0.0' };
  let pending = false;
  const selector = 'cart-drawer .product-upsell-container[data-upsell-type="cart-drawer"]';
  const root = () => window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  async function request(path, body) {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 25000);
    try {
      const response = await window.fetch(root() + path, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Upsell-Add': 'true' },
        signal: controller.signal,
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || String(response.status));
      return result;
    } finally {
      window.clearTimeout(timer);
    }
  }

  function setLoading(container, loading) {
    container.querySelectorAll('.upsell-toggle-input, .upsell-add-btn').forEach(control => {
      control.disabled = loading;
      control.classList.toggle('loading', loading);
      control.setAttribute('aria-busy', String(loading));
    });
    const overlay = container.querySelector('.upsell-loading-overlay');
    if (overlay) overlay.classList.toggle('hidden', !loading);
    const slider = container.querySelector('.upsell-toggle-slider');
    if (slider) slider.classList.toggle('loading', loading);
  }

  async function renderSections(sections) {
    if (!sections || !sections['cart-drawer']) {
      sections = await request('?sections=cart-drawer,cart-icon-bubble');
    }
    const fresh = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer && drawer.querySelector('.drawer__inner');
    const next = fresh.querySelector('cart-drawer .drawer__inner');
    if (!inner || !next) throw new Error('Missing cart drawer section');
    const scroll = inner.scrollTop;
    inner.innerHTML = next.innerHTML;
    inner.scrollTop = scroll;
    drawer.classList.toggle('is-empty', fresh.querySelector('cart-drawer').classList.contains('is-empty'));
    if (sections['cart-icon-bubble']) {
      const bubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const current = document.querySelector('#cart-icon-bubble');
      const replacement = bubble.querySelector('#cart-icon-bubble') || bubble.querySelector('.shopify-section');
      if (current && replacement) current.innerHTML = replacement.innerHTML;
    }
    if (window.TTFreeEbookGifts) window.TTFreeEbookGifts.decorate();
    if (typeof window.initSubscriptionUpgrade === 'function') window.initSubscriptionUpgrade();
    if (typeof window.initVariantSwapper === 'function') window.initVariantSwapper();
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart-drawer:updated', { bubbles: true }));
  }

  function showError(container) {
    if (!container.isConnected) return;
    let error = container.querySelector('[data-tt-upsell-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.ttUpsellError = 'true';
      error.setAttribute('role', 'alert');
      container.appendChild(error);
    }
    error.textContent = container.dataset.errorMessage;
  }

  async function update(container, add, toggle) {
    if (pending) {
      if (toggle) toggle.checked = !add;
      return;
    }
    const variantId = Number(container.dataset.variantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) {
      if (toggle) toggle.checked = !add;
      showError(container);
      return;
    }
    pending = true;
    setLoading(container, true);
    const priorError = container.querySelector('[data-tt-upsell-error]');
    if (priorError) priorError.remove();
    let saved = false;
    try {
      const sectionOptions = { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
      let result;
      if (add) {
        result = await request('cart/add.js', { items: [{ id: variantId, quantity: 1 }], ...sectionOptions });
      } else {
        const cart = await request('cart.js');
        const item = cart.items.find(line => Number(line.variant_id) === variantId && !line.selling_plan_allocation);
        result = item ? await request('cart/change.js', { id: item.key, quantity: 0, ...sectionOptions }) : {};
      }
      saved = true;
      await renderSections(result.sections);
    } catch (error) {
      if (!saved && toggle && toggle.isConnected) toggle.checked = !add;
      if (saved && window.TTFreeEbookGifts) await window.TTFreeEbookGifts.sync();
      showError(container);
    } finally {
      pending = false;
      setLoading(container, false);
      document.querySelectorAll(selector).forEach(node => setLoading(node, false));
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.upsell-add-btn');
    const container = button && button.closest(selector);
    if (!container) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!button.disabled) update(container, true);
  }, true);

  document.addEventListener('change', function (event) {
    const control = event.target;
    const container = control.closest(selector);
    if (!container) return;
    if (control.matches('.upsell-toggle-input')) {
      event.stopImmediatePropagation();
      update(container, control.checked, control);
    } else if (control.matches('.upsell-variant-select')) {
      event.stopImmediatePropagation();
      const option = control.options[control.selectedIndex];
      container.dataset.variantId = control.value;
      container.querySelectorAll('.upsell-toggle-input, .upsell-add-btn').forEach(node => { node.dataset.variantId = control.value; });
      container.querySelectorAll('.upsell-price, .btn-price, .upsell-price-below').forEach(node => { node.textContent = option.dataset.priceFormatted; });
      const compare = container.querySelector('.upsell-compare-price');
      if (compare) {
        compare.textContent = option.dataset.comparePriceFormatted || '';
        compare.style.display = Number(option.dataset.comparePrice) > Number(option.dataset.price) ? '' : 'none';
      }
      const image = container.querySelector('.upsell-image img');
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.srcset = option.dataset.image;
      }
    }
  }, true);
})();
